// src/pages/Home.jsx
import { Link } from "react-router-dom";
import ViewfinderFrame from "../components/ViewfinderFrame";
import ProcessSteps from "../components/ProcessSteps";
import PortfolioCard from "../components/PortfolioCard";
import CtaFinal from "../components/CtaFinal";
import usePageTitle from "../hooks/usePageTitle";
import { whatsappLink } from "../data/site";
import { PORTFOLIO } from "../data/portfolio";
import "./Home.css";

const HERO_VIDEO = "/videos/drone.mp4";

const AUDIENCE = [
  {
    title: "Corretor autônomo",
    desc: "Anúncio que se destaca no portal e no Instagram sem precisar contratar fotógrafo e piloto separados.",
  },
  {
    title: "Imobiliária",
    desc: "Plano mensal com preço por imóvel menor, agenda fixa e padrão visual único para toda a carteira.",
  },
  {
    title: "Construtora e lançamento",
    desc: "Vídeo em dois formatos, golden hour e fotos em volume para campanha de lançamento.",
  },
];

const SERVICES = [
  {
    tag: "AR · 4K",
    title: "Vídeo aéreo com drone",
    desc: "Fachada, entorno, vista e localização em tomadas aéreas editadas com trilha.",
  },
  {
    tag: "FOTO · HDR",
    title: "Fotos profissionais",
    desc: "Internas, externas e aéreas, tratadas para portal e redes sociais.",
  },
  {
    tag: "TOUR · 90s",
    title: "Tour em vídeo pelos ambientes",
    desc: "Passeio contínuo pelo imóvel, estabilizado, mostrando a planta na prática.",
  },
  {
    tag: "REELS · 9:16",
    title: "Formato para redes",
    desc: "Versão vertical pronta para Reels, TikTok e Stories, além da horizontal para site e YouTube.",
  },
];

const OFERTA_MSG =
  "Olá! Quero aproveitar a oferta de entrada da D-Rec: pacote Imóvel pelo preço do Aéreo.";

function Home() {
  usePageTitle("D-Rec Produções — Vídeo e fotos de imóveis com drone em Recife");

  const preview = PORTFOLIO.slice(0, 3);

  return (
    <>
      {/* 4.1 Hero */}
      <section className="hero">
        <video className="hero-video" autoPlay muted loop playsInline>
          <source src={HERO_VIDEO} type="video/mp4" />
        </video>
        <div className="hero-scrim" />

        <ViewfinderFrame tag="REC · RMR" className="hero-frame">
          <div className="hero-content">
            <span className="eyebrow">Vídeo e fotografia de imóveis</span>
            <h1 className="hero-title">Seu imóvel visto de cima. E de dentro.</h1>
            <p className="hero-sub">
              Drone, fotos profissionais e tour em vídeo para corretores e imobiliárias da
              Região Metropolitana do Recife. Material pronto em 48h, no formato certo para
              portais, Instagram e WhatsApp.
            </p>
            <div className="hero-actions">
              <a href={whatsappLink()} target="_blank" rel="noreferrer" className="btn btn-primary">
                Pedir orçamento no WhatsApp
              </a>
              <Link to="/servicos" className="btn btn-ghost">
                Ver pacotes e preços
              </Link>
            </div>
            <ul className="hero-indicators">
              <li>Entrega em 48h</li>
              <li>Drone + câmera no mesmo pacote</li>
              <li>Piloto e fotógrafo na mesma visita</li>
            </ul>
          </div>
        </ViewfinderFrame>
      </section>

      {/* 4.2 Faixa de oferta de entrada */}
      <div className="offer-strip">
        <div className="container offer-strip-inner">
          <p>
            Primeiro imóvel: pacote Imóvel pelo preço do Aéreo — R$ 390 em vez de R$ 690.
            Válido uma vez por imobiliária.
          </p>
          <a href={whatsappLink(OFERTA_MSG)} target="_blank" rel="noreferrer">
            Quero aproveitar →
          </a>
        </div>
      </div>

      {/* 4.3 Para quem é */}
      <section className="home-section">
        <div className="section-head">
          <span className="eyebrow">Para quem</span>
          <h2 className="section-title">Feito para quem vende imóvel</h2>
        </div>
        <div className="container card-grid">
          {AUDIENCE.map((item) => (
            <div key={item.title} className="card">
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 4.4 O que entregamos */}
      <section className="home-section">
        <div className="section-head">
          <span className="eyebrow">Serviços</span>
          <h2 className="section-title">Tudo que o anúncio precisa, numa visita só</h2>
        </div>
        <div className="container card-grid">
          {SERVICES.map((item) => (
            <div key={item.title} className="card">
              <span className="card-tag">{item.tag}</span>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
        <div className="container section-more">
          <Link to="/servicos" className="link-arrow">
            Ver pacotes e preços →
          </Link>
        </div>
      </section>

      {/* 4.5 Como funciona */}
      <section className="home-section">
        <div className="section-head">
          <span className="eyebrow">Processo</span>
          <h2 className="section-title">Do agendamento à entrega em 48h</h2>
        </div>
        <ProcessSteps />
      </section>

      {/* 4.6 Prévia do portfólio */}
      <section className="home-section">
        <div className="section-head">
          <span className="eyebrow">Portfólio</span>
          <h2 className="section-title">Alguns dos nossos voos</h2>
        </div>
        <div className="container portfolio-grid">
          {preview.map((item) => (
            <PortfolioCard key={item.id} item={item} />
          ))}
        </div>
        <div className="container section-more">
          <Link to="/portfolio" className="link-arrow">
            Ver portfólio completo →
          </Link>
        </div>
      </section>

      {/* 4.7 CTA final */}
      <CtaFinal />
    </>
  );
}

export default Home;
